import { render, staticRenderFns } from "./bjCertificate.vue?vue&type=template&id=7d257356&scoped=true"
import script from "./bjCertificate.vue?vue&type=script&lang=js"
export * from "./bjCertificate.vue?vue&type=script&lang=js"
import style0 from "./bjCertificate.vue?vue&type=style&index=0&id=7d257356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d257356",
  null
  
)

export default component.exports